import React from 'react';
import styled from 'styled-components';
import { Row, Column, Card, Text } from '@dls/web';
import mockIcon from '../../assets/mock.png';
import networkIcon from '../../assets/computer.png';
import loggerIcon from '../../assets/logger.png';
import { store } from '../../app/store';

export const PRODUCT = {
  MOCK: 'MOCK',
  NETWORK: 'NETWORK',
  LOGGER: 'LOGGER'
};

type ProductsProps = {
  onSelect: (item: string) => void;
};

const StyledProducts = styled.div`
  padding: 16px 32px 64px;
  margin-top: 24px;
`;

const TextActive = styled(Text)`
  color: teal;
`;

export const Products = ({ onSelect }: ProductsProps) => {
  const { mock, network, logger } = store.getState();

  const items = [
    {
      imageSrc: mockIcon,
      imageAlt: 'mock logo',
      active: !!mock?.mock,
      text: PRODUCT.MOCK,
      onClick() {
        onSelect(PRODUCT.MOCK);
      }
    },
    {
      imageSrc: networkIcon,
      imageAlt: 'network logo',
      active: network?.enabled,
      text: PRODUCT.NETWORK,
      onClick() {
        onSelect(PRODUCT.NETWORK);
      }
    },
    {
      imageSrc: loggerIcon,
      imageAlt: 'logger logo',
      active: logger?.enabled,
      text: PRODUCT.LOGGER,
      onClick() {
        onSelect(PRODUCT.LOGGER);
      }
    }
  ];

  return (
    <StyledProducts>
      <Row center="xs">
        {items.map((item, index) => (
          <Column xs={12} sm={4} md={3} key={index}>
            <Card shadow="sm" radius="sm" padding="sm" onClick={item.onClick}>
              <Card.Content>
                <Row middle="xs" center="xs">
                  <Column xs={12}>
                    <img
                      src={item.imageSrc}
                      width="80"
                      height="80"
                      alt={item.imageAlt}
                    />
                  </Column>
                  <Column xs={12}>
                    <Text>{item.text}</Text>
                    {item.active && <TextActive>(Active)</TextActive>}
                  </Column>
                </Row>
              </Card.Content>
            </Card>
          </Column>
        ))}
      </Row>
    </StyledProducts>
  );
};
